export const walletRoutes = [
  {
    path: "main",
    name: "main-wallet",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.wallet.mainWallet"
    },
    component: () => import("@/views/panel/WalletPage")
  },
  {
    path: "spot",
    name: "spot-wallet",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.wallet.spotWallet"
    },
    component: () => import("@/views/panel/Market/assets")
  }
];
